import colors from 'styles/colors'

export default function getGradient(time, opacity=1) {
  if (!time) {
    return [colors['color-navy'], colors['color-navy-dark']] // default
  }
  const hour = time.hour()
  if (5 <= hour && hour < 8) {
    return [`rgba(255, 241, 101, ${opacity})`, `rgba(60, 185, 240, ${opacity})`] // 5am to 8am
  } else if (8 <= hour && hour < 19) {
    return [`rgba(169, 252, 224, ${opacity})`, `rgba(21, 122, 251, ${opacity})`] // 8am to 7pm
  } else if (19 <= hour && hour < 21) {
    return [`rgba(184, 66, 166, ${opacity})`, `rgba(255, 157, 119, ${opacity})`] // 7pm to 9pm
  } else {
    return [`rgba(21, 122, 251, ${opacity})`, `rgba(5, 53, 111, ${opacity})`] // 9pm to 5am
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TitleCard/getGradient.js